import { Component, OnInit, inject } from '@angular/core';
import { BrowserEventService } from '@rct/lynx-lobbies-shared-lib';
import { TranslateService } from '@ngx-translate/core';
import { ModalIconType } from '../../../enums/modal-icon-type';
import { LynxLobbyService } from '../../../services/lobby.service';
import { LynxModalService } from '../../../services/modal.service';
import { LynxUserService } from '../../../services/user.service';

@Component({
    selector: 'lynx-userbalance',
    templateUrl: './userbalance.component.html',
    styleUrls: ['./userbalance.component.scss'],
    standalone: false
})
export class UserbalanceComponent implements OnInit {
  private userService = inject(LynxUserService);
  private modalService = inject(LynxModalService);
  private browserEventService = inject(BrowserEventService);
  private translateService = inject(TranslateService);
  private lobbyService = inject(LynxLobbyService);

  userBalance: number | null;
  isMobile: boolean = this.browserEventService.isMobile();

  ngOnInit() {
    this.userService.balance$.subscribe((value) => (this.userBalance = value));
  }

  reloadBalance() {
    this.userService.getUserBalance().subscribe(
      (_) => {},
      (error) => {
        this.modalService.dispatch({
          icon: ModalIconType.WARNING,
          title: 'Error.General.Title',
          content: ['Error.General.Description.0', 'Error.General.Description.1'],
          data: {
            LobbyID: this.lobbyService.lobbyId
          }
        });
      }
    );
  }
}
